"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
// login.component.ts
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const common_1 = require("../../../@inax/common");
let ServiceLoginComponent = class ServiceLoginComponent {
    constructor(_userService, _router) {
        this._userService = _userService;
        this._router = _router;
        this.loggedIn = false;
        this.username = "";
        this.password = "";
        this.message = "";
        this.loggedIn = _userService.isAuthenticated();
    }
    ngOnInit() {
    }
    login() {
        if (!this.loggedIn) {
            this.message = "";
            this._userService.login(this.username, this.password).subscribe((result) => {
                if (result) {
                    this._router.navigate(['Home']);
                }
                else {
                    this.message = "Not logged in";
                    console.warn(this.message);
                    this.loggedIn = this._userService.isAuthenticated();
                }
            });
        }
    }
    logout() {
        if (this.loggedIn) {
            this._userService.logout();
            this.loggedIn = this._userService.isAuthenticated();
        }
    }
    useAdmin() {
        this.username = 'admin@insite-gmbh.de';
        this.password = 'InsiteAdm#1';
        this.login();
    }
    useUser() {
        this.username = 'user@insite-gmbh.de';
        this.password = 'InsiteUsr#1';
        this.login();
    }
};
ServiceLoginComponent = __decorate([
    core_1.Component({
        selector: 'service-login',
        templateUrl: 'app/components/serviceLogin/serviceLogin.component.html',
        styleUrls: ['app/components/serviceLogin/serviceLogin.component.css']
    }),
    __metadata("design:paramtypes", [common_1.ProfileService,
        router_1.Router])
], ServiceLoginComponent);
exports.ServiceLoginComponent = ServiceLoginComponent;
